/* global Sys */
Sys.ns("Sys");
Sys.ns("Services");

/**
 * The data model for global parameters.
 *
 * Instantiates itself.
 *
 * @deprecated 8.0.0. Will be replaced by an instance of Core.Model.
 * @class Sys.Storage
 * @extends Sys.Observable
 */
Sys.Storage = {

    constructor: function() {
        Sys.Storage.superclass.constructor.apply(this, arguments);
        this.init();
    },

    /**
     * Initializes the storage.
     *
     * @private
     * @returns {void}
     */
    init: function() {
        this.data = {};
    },

    /**
     * Read the data associated with the provided key.
     *
     * @param {string} key The key.
     * @returns {*} The data associated with the key.
     */
    readData: function(key) {
        return this.data[key];
    },

    /**
     * Store the provided data under the provided key.
     *
     * @param {string} key The key.
     * @param {*} dataToStore The data to store.
     * @returns {*} The data stored.
     */
    storeData: function(key, dataToStore) {
        this.data[key] = dataToStore;

        return this.data[key];
    },

    /**
     * Remove the data associated with the key.
     *
     * @param {string} key The key.
     * @returns {void}
     */
    removeData: function(key) {
        delete this.data[key];
    }
};

Sys.Storage = Sys.extend(Sys.Observable, Sys.Storage, "Sys.Storage");

